import EmploymentTypeComponents from "../components/EmploymentType";
import useEmploymentType from "../hooks/useEmploymentType";

import { PAGE_TYPE } from "../schemas/incomeDeductionSchema";

const EmploymentType = () => {
  const useEmploymentTypeProps = useEmploymentType({
    pageType: PAGE_TYPE.INCOME,
  });
  return <EmploymentTypeComponents {...useEmploymentTypeProps} />;
};

export default EmploymentType;
